export const SEND_CERTIFICATE_MAIL_REQUEST = 'SEND_CERTIFICATE_MAIL_REQUEST';
export const SEND_CERTIFICATE_MAIL_SUCCESS = 'SEND_CERTIFICATE_MAIL_SUCCESS';
export const SEND_CERTIFICATE_MAIL_FAIL = 'SEND_CERTIFICATE_MAIL_FAIL';

export const SEND_MAIL_REQUEST = 'SEND_MAIL_REQUEST';
export const SEND_MAIL_SUCCESS = 'SEND_MAIL_SUCCESS';
export const SEND_MAIL_FAIL = 'SEND_MAIL_FAIL';

export const AUTHENITCATE_EMAIL_PASS_REQUEST = 'AUTHENITCATE_EMAIL_PASS_REQUEST';
export const AUTHENITCATE_EMAIL_PASS_SUCCESS = 'AUTHENITCATE_EMAIL_PASS_SUCCESS';
export const AUTHENITCATE_EMAIL_PASS_FAIL = 'AUTHENITCATE_EMAIL_PASS_FAIL';

export const RESET_REDUCERS = "RESET_REDUCERS";

export const CLEAR_ERRORS = "CLEAR_ERRORS";